import styles from './SectionLabel.module.css';

type Props = {
  className?: string;
  label: 'About you' | 'Your tastes';
};

export function SectionLabel({ className, label }: Props) {
  return (
    <span className={[styles.container, className].join(' ')}>{label}</span>
  );
}
